/* tslint:disable */
/* eslint-disable */
/**
 * Y-Sports backend-next Management API
 * Composed management-facing contract for `backend-next`. This spec is an aggregation layer over module-scoped contracts and should reference canonical module definitions instead of copying them. 
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { TrainingFrequencyType } from './TrainingFrequencyType';
import {
    TrainingFrequencyTypeFromJSON,
    TrainingFrequencyTypeFromJSONTyped,
    TrainingFrequencyTypeToJSON,
    TrainingFrequencyTypeToJSONTyped,
} from './TrainingFrequencyType';
import type { TrainingPaymentMode } from './TrainingPaymentMode';
import {
    TrainingPaymentModeFromJSON,
    TrainingPaymentModeFromJSONTyped,
    TrainingPaymentModeToJSON,
    TrainingPaymentModeToJSONTyped,
} from './TrainingPaymentMode';
import type { TrainingType } from './TrainingType';
import {
    TrainingTypeFromJSON,
    TrainingTypeFromJSONTyped,
    TrainingTypeToJSON,
    TrainingTypeToJSONTyped,
} from './TrainingType';

/**
 * 
 * @export
 * @interface TrainingUpdateRequest
 */
export interface TrainingUpdateRequest {
    /**
     * 
     * @type {string}
     * @memberof TrainingUpdateRequest
     */
    name?: string;
    /**
     * 
     * @type {string}
     * @memberof TrainingUpdateRequest
     */
    description?: string | null;
    /**
     * 
     * @type {TrainingFrequencyType}
     * @memberof TrainingUpdateRequest
     */
    frequencyType?: TrainingFrequencyType;
    /**
     * 
     * @type {TrainingPaymentMode}
     * @memberof TrainingUpdateRequest
     */
    paymentMode?: TrainingPaymentMode;
    /**
     * 
     * @type {TrainingType}
     * @memberof TrainingUpdateRequest
     */
    trainingType?: TrainingType;
    /**
     * 
     * @type {Date}
     * @memberof TrainingUpdateRequest
     */
    seasonStartDate?: Date | null;
    /**
     * 
     * @type {Date}
     * @memberof TrainingUpdateRequest
     */
    seasonEndDate?: Date | null;
    /**
     * 
     * @type {string}
     * @memberof TrainingUpdateRequest
     */
    frequencyPattern?: string | null;
    /**
     * 
     * @type {string}
     * @memberof TrainingUpdateRequest
     */
    startTime?: string;
    /**
     * 
     * @type {string}
     * @memberof TrainingUpdateRequest
     */
    endTime?: string;
    /**
     * 
     * @type {number}
     * @memberof TrainingUpdateRequest
     */
    trainingFee?: number | null;
    /**
     * 
     * @type {boolean}
     * @memberof TrainingUpdateRequest
     */
    active?: boolean;
}



/**
 * Check if a given object implements the TrainingUpdateRequest interface.
 */
export function instanceOfTrainingUpdateRequest(value: object): value is TrainingUpdateRequest {
    return true;
}

export function TrainingUpdateRequestFromJSON(json: any): TrainingUpdateRequest {
    return TrainingUpdateRequestFromJSONTyped(json, false);
}

export function TrainingUpdateRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): TrainingUpdateRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'name': json['name'] == null ? undefined : json['name'],
        'description': json['description'] == null ? undefined : json['description'],
        'frequencyType': json['frequencyType'] == null ? undefined : TrainingFrequencyTypeFromJSON(json['frequencyType']),
        'paymentMode': json['paymentMode'] == null ? undefined : TrainingPaymentModeFromJSON(json['paymentMode']),
        'trainingType': json['trainingType'] == null ? undefined : TrainingTypeFromJSON(json['trainingType']),
        'seasonStartDate': json['seasonStartDate'] == null ? undefined : (new Date(json['seasonStartDate'])),
        'seasonEndDate': json['seasonEndDate'] == null ? undefined : (new Date(json['seasonEndDate'])),
        'frequencyPattern': json['frequencyPattern'] == null ? undefined : json['frequencyPattern'],
        'startTime': json['startTime'] == null ? undefined : json['startTime'],
        'endTime': json['endTime'] == null ? undefined : json['endTime'],
        'trainingFee': json['trainingFee'] == null ? undefined : json['trainingFee'],
        'active': json['active'] == null ? undefined : json['active'],
    };
}

export function TrainingUpdateRequestToJSON(json: any): TrainingUpdateRequest {
    return TrainingUpdateRequestToJSONTyped(json, false);
}

export function TrainingUpdateRequestToJSONTyped(value?: TrainingUpdateRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'name': value['name'],
        'description': value['description'],
        'frequencyType': TrainingFrequencyTypeToJSON(value['frequencyType']),
        'paymentMode': TrainingPaymentModeToJSON(value['paymentMode']),
        'trainingType': TrainingTypeToJSON(value['trainingType']),
        'seasonStartDate': value['seasonStartDate'] == null ? value['seasonStartDate'] : value['seasonStartDate'].toISOString().substring(0,10),
        'seasonEndDate': value['seasonEndDate'] == null ? value['seasonEndDate'] : value['seasonEndDate'].toISOString().substring(0,10),
        'frequencyPattern': value['frequencyPattern'],
        'startTime': value['startTime'],
        'endTime': value['endTime'],
        'trainingFee': value['trainingFee'],
        'active': value['active'],
    };
}

